import { CheckboxProps } from '@material-ui/core';

export const checkbox: CheckboxProps = {
  disableRipple: true,
  disableFocusRipple: true,
  disableTouchRipple: true,
  color: 'primary',
};
